import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-blue",
  "use": "icon-arrow-blue-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" viewBox=\"0 0 12 12\" id=\"icon-arrow-blue\"><g><g transform=\"matrix(1,6.123234262925839e-17,-6.123234262925839e-17,1,2.220446049250313e-16,0)\"><path d=\"M6,9.41421L10.70711,4.707107L9.29289,3.292893L6,6.585789999999999L2.707107,3.292893L1.2928929999999998,4.707107L6,9.41421Z\" fill-rule=\"evenodd\" fill=\"#0662BB\" fill-opacity=\"1\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol